import { useEffect, useState } from 'react';
import Modal from '../../UI/Modal/Modal';
import '../Administracija.css';
import toast from 'react-hot-toast';
import MenijiGridProvider from './MenijiGridProvider';
import OInput from '../../UI/FormControls/OInput';

const initialConfig = {
  url: 'vracanje_menija',
};

function Meniji(props) {
  const [formData, setFormData] = useState({ naziv: '' });
  const [status, setStatus] = useState(1);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    props.sendRequest(initialConfig);
    props.handleRefreshData(initialConfig);
  }, []);

  const groupData = (form = formData) => {
    const config = {
      url:
        status === 1
          ? 'unos_menija_objekat'
          : status === 2
          ? 'izmena_menija_objekat'
          : status === 3
          ? 'brisanje_menija'
          : '',
      status,
      method: 'POST',
      data: {
        naziv: form ? form.naziv : '',
        id: form ? form.id : 0,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    props.sendRequest(config);
  };

  useEffect(() => {
    if (props.save === true) {
      groupData();
    }
    props.handleSave(false);
  }, [props.save]);

  useEffect(() => {
    const newFormData = {
      ...formData,
      naziv: '',
      id: 0,
    };
    setFormData(newFormData);
    setStatus(1);
  }, [props.data]);

  const handleRowClick = (event) => {
    const newFormData = {
      ...formData,
      naziv: event.row.naziv,
      id: event.row.id,
      vremeProm: new Date(),
      idKorProm: +localStorage.getItem('idKorisnika'),
    };
    setStatus(2);
    setFormData(newFormData);
  };

  const handleChange = (event) => {
    const newFormData = {
      ...formData,
      [event.target.name]: event.target.value,
    };
    setFormData(newFormData);
  };

  const handleOpenDelete = (id) => {
    setOpenDelete(true);
    const newFormData = {
      ...formData,
      id,
    };
    setFormData(newFormData);
  };

  // f-ja za brisanje podatka iz grida
  const handleObrisi = () => {
    const config = {
      url: 'brisanje_menija',
      status: 3,
      method: 'POST',
      data: {
        naziv: '',
        id: formData.id,
        vremeProm: new Date(),
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    // slanje zahteva na api
    props.sendRequest(config);
    // zatvaranje modala i setovanje form data na pocetno stanje
    setOpenDelete(false);
    const newFormData = {
      ...formData,
      id: 0,
    };
    setFormData(newFormData);
  };

  // eslint-disable-next-line no-unused-expressions
  props.isSuccess && toast.success('Meni uspešno unet');

  return (
    <>
      {openDelete && (
        <Modal
          title="Upozorenje!"
          message="Da li ste sigurni da želite da obrišete izabranu stavku?"
          type="warning"
          onClose={() => setOpenDelete(false)}
          onConfirm={handleObrisi}
        />
      )}
      {props.error && (
        <Modal
          title="Greška!"
          message={props.error}
          type="error"
          onClose={props.clearError}
        />
      )}
      <div>
        <OInput
          label="Naziv menija"
          name="naziv"
          value={formData.naziv}
          id="naziv"
          type="text"
          style={{ width: '300px' }}
          handleChange={handleChange}
        />
      </div>
      <MenijiGridProvider
        data={props.data}
        loading={props.isLoading}
        handleOpenDelete={handleOpenDelete}
        handleRowClick={handleRowClick}
      />
    </>
  );
}

export default Meniji;
